import type { departments as en } from '@/i18n/locales/en/departments';
import type { Translation } from '@/i18n/types';

export const departments: Translation<typeof en> = {
  page: {
    title: 'Departamentos',
    leadPersonal: 'Departamentos de los que eres miembro.',
    leadCompany: 'Departamentos en {{company}}.',
  },
  list: {
    cardTitle: 'Departamentos',
    name: 'Nombre',
    company: 'Empresa',
    statistics: 'Estadísticas',
    collectiveConsent: 'Consentimiento colectivo',
    inForce: 'vigente',
    none: '—',
    unattached: 'sin asignar',
    empty: 'Aún no hay departamentos aquí.',
    newDepartment: 'Nuevo departamento',
  },
  compare: {
    cardTitle: 'Comparación de departamentos',
    pageTitle: 'Comparación de departamentos',
    lead: 'Comparando los departamentos cuyas estadísticas puedes ver.',
    empty: 'Ningún departamento aquí tiene estadísticas que puedas ver.',
  },
  detail: {
    thisDepartment: 'departamento',
    edit: 'Editar',
    setVisibility: 'Definir visibilidad',
    collectiveConsent: 'Consentimiento colectivo',
    coach: 'Entrenador',
    category: 'Categoría',
    type: 'Tipo',
    statistics: 'Estadísticas',
    notRecorded: 'no registrado',
    membersCardTitle: 'Miembros',
    statsCardTitle: 'Estadísticas',
    settingsCardTitle: 'Ajustes',
    addPerson: 'Añadir persona',
    name: 'Nombre',
    nickname: 'Apodo',
    login: 'Acceso',
    yes: 'sí',
    no: 'no',
    noMembers: 'No hay miembros.',
  },
  form: {
    newTitle: 'Nuevo departamento',
    newLead:
      'Todo departamento nuevo empieza en modo solo-agregado — el estado que protege la privacidad es el que obtienes sin hacer nada.',
    name: 'Nombre',
    category: 'Categoría',
    type: 'Tipo',
    cancel: 'Cancelar',
    create: 'Crear departamento',
    editTitle: 'Editar departamento',
    save: 'Guardar',
    deleteCardTitle: 'Eliminar',
    deleteButton: 'Eliminar este departamento',
    deleteConfirm: '¿Eliminar {{name}} definitivamente?',
    deleteKeep: 'Conservarlo',
    deleteYes: 'Sí, eliminar',
    visibilityTitle: 'Visibilidad de las estadísticas',
    visibilityLead:
      'individual no expone a nadie por sí sola: permite el acceso individual cuando una base de consentimiento cubre al miembro. Cambiar a individual sin un registro colectivo crea una fila de consentimiento pendiente para cada miembro actual.',
    visibilityAggregate: 'agregado — solo cifras de grupo',
    visibilityIndividual: 'individual — acceso por miembro cuando el consentimiento lo cubre',
    collectiveConsentTitle: 'Base del consentimiento colectivo',
    collectiveConsentLead:
      'Mientras un registro colectivo esté vigente, cubre a todos los miembros de {{name}}, sea cual sea su respuesta personal. Las filas propias de los miembros se conservan y vuelven a tener efecto cuando se revoca.',
    collectiveConsentNote: 'Acuerdo fuera de la plataforma (identifícalo con precisión)',
    collectiveConsentRecord: 'Registrar base colectiva',
    revokeCardTitle: 'Revocar',
    revokeButton: 'Revocar la base colectiva',
  },
};
